var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 458.272,
    height: 101.301,
    viewBox: "0 0 458.272 101.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(-68.501 -159.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M215.5,228.523h-8.367l-16.988-23.906-7.911,7.516v16.39H175.9v-47.3h6.336v23.461l23.821-23.461h8.554l-20.058,19.168Z",
    fill: "#e40039",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M256.7,228.523H220.922v-47.3H255.59v5.613H227.262v14.457h26.5v5.617h-26.5v16H256.7Z",
    fill: "#e40039",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M304.5,181.223l-19.074,27.265v20.035h-6.379V208.488l-18.461-27.265H268.3l14.308,21.6s5.754-8.519,14.5-21.6Z",
    fill: "#e40039",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M352.051,181.223l-18.746,47.3h-6.473l-18.555-47.3H315.1l15.062,40.785,15.457-40.785Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M392.246,228.523h-7.16l-5.613-14.39h-20l-5.293,14.39h-6.7l18.395-47.3H372.7Zm-14.707-19.359q-5.883-15.357-6.629-17.437c-.5-1.387-1.574-3.641-1.574-3.641s-1.684,4.207-2.707,6.914l-5.356,14.164Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M427.176,228.523H397.211v-47.3h6.34V222.91h23.625Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M472.355,208.582a52.8,52.8,0,0,1-.406,6.742,18.611,18.611,0,0,1-2.164,6.379,13.624,13.624,0,0,1-5.683,5.453q-3.937,2.173-10.5,2.176a23.422,23.422,0,0,1-10.325-1.937,13.292,13.292,0,0,1-5.75-5,17.561,17.561,0,0,1-2.336-6.387,48.83,48.83,0,0,1-.511-7.426V181.223h6.343v27.269a37.9,37.9,0,0,0,.618,7.336,9.941,9.941,0,0,0,3.273,5.473q2.637,2.385,8.168,2.387,5.578,0,8.395-1.907a8.659,8.659,0,0,0,3.66-5.082,32.469,32.469,0,0,0,.847-8.207V181.223h6.371Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M518.785,228.523H483.012v-47.3h34.66v5.613H489.344v14.457h26.5v5.617h-26.5v16h29.441Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M122.988,166.781l-7.312,12.282,6.836,11.73L128,181.316,146.867,213.2H109.141l-7,11.824h55.031a5.906,5.906,0,0,0,5.836-5.914,5.938,5.938,0,0,0-.832-3.043L133,166.781a5.8,5.8,0,0,0-10.012,0Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M98.52,166.781,69.332,216.07a5.977,5.977,0,0,0-.074,5.953,5.847,5.847,0,0,0,5.086,3H88.617L95.629,213.2H84.652l18.875-31.887,5.387,9.1.008.02,6.805,11.484.007.019.032-.062,6.7,11.324h13.547l-20.293-34.277-7.188-12.145a5.795,5.795,0,0,0-10.011,0Z",
    fill: "#009ee0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M81.652,236.625a5.953,5.953,0,0,0-.066,5.945,5.826,5.826,0,0,0,5.086,3h58.359a5.917,5.917,0,0,0,5-8.949l-6.882-11.594h-13.6l5.18,8.715H96.973l5.172-8.738,7-11.82h-.012l6.676-11.282-6.793-11.484Z",
    fill: "#e40039",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M308.082,255.3V235.941h2.465v17.207h7.105V255.3Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M321.887,249.238c0,3.778,1.015,4.528,2.738,4.528a2.427,2.427,0,0,0,2.352-2.571h2.418c-.028,3-1.879,4.368-4.719,4.368-2.871,0-5.145-.856-5.145-6.836,0-3.969.449-7.235,5.145-7.235,3.863,0,4.824,2.117,4.824,6.594v1.152Zm5.277-1.664c0-3.937-1.1-4.422-2.7-4.422-1.395,0-2.551.672-2.574,4.422Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M333.379,241.758v-2.6l2.2-.992v3.59h2.949v1.664h-2.949V251.7c0,.856,0,1.957,2.012,1.957.16,0,.5-.058.988-.105v1.683c-.727.059-1.449.219-2.172.219-2.09,0-3.031-.863-3.031-2.414v-9.621h-2.223v-1.664Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 1.613,
    height: 5.543,
    transform: "translate(341.207 235.945)",
    fill: "#919394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M351.285,255.563c-2.918,0-4.742-1.29-4.66-4.4h2.488c0,.777.028,2.6,2.254,2.6A2.05,2.05,0,0,0,353.7,251.7c0-2.414-6.754-2.465-6.754-6.515,0-1.418.856-3.7,4.668-3.7,2.407,0,4.473,1.153,4.289,3.832h-2.441a1.9,1.9,0,0,0-2.117-2.172,1.85,1.85,0,0,0-2.09,1.821c0,2.386,6.754,2.336,6.754,6.461C356,254.41,353.965,255.563,351.285,255.563Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M367.52,255.3h-2.2V235.945h2.2v7.18h.082a3.44,3.44,0,0,1,2.976-1.637c4.367,0,4.477,3.891,4.477,7.266,0,5.949-2.2,6.805-4.371,6.805a3.346,3.346,0,0,1-3.106-1.875h-.058Zm2.472-1.535c2.758,0,2.758-2.946,2.758-4.985,0-3.617-.32-5.5-2.68-5.5-2.441,0-2.55,2.895-2.55,4.692C367.52,250.039,367.285,253.766,369.992,253.766Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M385.777,241.758h2.2v10.726c0,.938.054,1.875.136,2.813h-2.332V253.66H385.7a3.887,3.887,0,0,1-3.429,1.9c-2.36,0-3.649-1.172-3.649-3.481v-10.32h2.2v9.383c0,1.632.75,2.734,2.3,2.734,1.18,0,2.656-.883,2.656-3.137Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M391.754,235.945h2.461V238.3h-2.461Zm2.328,19.356h-2.2V241.762h2.2Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1179",
    "data-name": "Rectangle 1179",
    width: 2.195,
    height: 19.355,
    transform: "translate(397.836 235.945)",
    fill: "#919394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M410.988,235.945h2.2V255.3h-2.2v-1.613h-.05a3.348,3.348,0,0,1-3.11,1.875c-2.172,0-4.363-.856-4.363-6.805,0-3.375.1-7.266,4.473-7.266a3.425,3.425,0,0,1,2.972,1.637h.078Zm-2.539,7.344c-2.363,0-2.683,1.875-2.683,5.492,0,2.039,0,4.985,2.761,4.985,2.461,0,2.461-3.055,2.461-5.789C410.988,246.18,410.887,243.289,408.449,243.289Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M427.258,252.773h.055l3.246-11.015h2.379L426.8,260.414h-2.282l1.528-5.117-4.578-13.539h2.543Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M434.707,248.727c0-3.969.457-7.239,5.145-7.239s5.148,3.27,5.148,7.239c0,5.976-2.281,6.836-5.148,6.836S434.707,254.7,434.707,248.727Zm7.988-.938c0-3.7-1.156-4.5-2.843-4.5s-2.836.8-2.836,4.5c0,4.4.562,5.977,2.836,5.977S442.7,252.188,442.7,247.789Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M455.719,241.758h2.2v10.726c0,.938.059,1.875.137,2.813h-2.336V253.66h-.082a3.883,3.883,0,0,1-3.426,1.9c-2.363,0-3.645-1.172-3.645-3.481v-10.32h2.2v9.383c0,1.632.75,2.734,2.3,2.734,1.184,0,2.653-.883,2.653-3.137Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M464.16,243.8h.055c.91-2.07,2.039-2.3,4.18-2.3v2.278c-.188-.028-.4-.059-.586-.079a4.045,4.045,0,0,0-.594-.054c-2.438,0-3.055,1.847-3.055,3.672V255.3h-2.2V241.758h2.2Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M476.57,235.945h2.465V238.3H476.57ZM478.9,255.3h-2.2V241.762h2.2Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M489.859,235.945h2.2V255.3h-2.2v-1.613h-.05a3.349,3.349,0,0,1-3.114,1.875c-2.168,0-4.367-.856-4.367-6.805,0-3.375.11-7.266,4.481-7.266a3.43,3.43,0,0,1,2.972,1.637h.078Zm-2.546,7.344c-2.356,0-2.676,1.875-2.676,5.492,0,2.039,0,4.985,2.758,4.985,2.464,0,2.464-3.055,2.464-5.789C489.859,246.18,489.754,243.289,487.313,243.289Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M498.246,249.238c0,3.778,1.02,4.528,2.734,4.528a2.433,2.433,0,0,0,2.364-2.571h2.414c-.028,3-1.879,4.368-4.723,4.368-2.867,0-5.144-.856-5.144-6.836,0-3.969.453-7.235,5.144-7.235,3.86,0,4.828,2.117,4.828,6.594v1.152Zm5.285-1.664c0-3.937-1.1-4.422-2.707-4.422-1.394,0-2.551.672-2.578,4.422Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M516.473,253.336h-.051a3.322,3.322,0,0,1-3.406,2.227c-2.871,0-3.7-1.848-3.7-4.45,0-4.1,4.02-4.289,7.106-4.211.051-1.793.082-3.746-2.281-3.746a2,2,0,0,0-2.118,2.407h-2.382c.1-3.028,1.711-4.075,4.578-4.075,3.488,0,4.4,1.8,4.4,4.075v6.519a21.626,21.626,0,0,0,.27,3.219h-2.414Zm-4.957-2.063c0,1.313.64,2.493,2.117,2.493,1.34,0,3-.832,2.789-5.2C514.328,248.594,511.516,248.406,511.516,251.273Z",
    fill: "#919394",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M518.051,159.113a9.013,9.013,0,0,1,4.3,1.129,7.98,7.98,0,0,1,3.257,3.231,8.764,8.764,0,0,1,.016,8.715,8.09,8.09,0,0,1-3.23,3.23,8.759,8.759,0,0,1-8.684,0,8.145,8.145,0,0,1-3.234-3.23,8.735,8.735,0,0,1,.015-8.715,8,8,0,0,1,3.27-3.231A8.983,8.983,0,0,1,518.051,159.113Zm0,1.45a7.437,7.437,0,0,0-3.582.941,6.712,6.712,0,0,0-2.719,2.7,7.247,7.247,0,0,0-.023,7.266,6.9,6.9,0,0,0,2.7,2.7,7.276,7.276,0,0,0,7.242,0,6.859,6.859,0,0,0,2.7-2.7,7.285,7.285,0,0,0-.019-7.266,6.7,6.7,0,0,0-2.723-2.7A7.421,7.421,0,0,0,518.051,160.563Zm-3.828,12.109v-9.391h3.226a7.845,7.845,0,0,1,2.4.258,2.35,2.35,0,0,1,1.179.906,2.432,2.432,0,0,1,.442,1.383,2.506,2.506,0,0,1-.735,1.789,2.92,2.92,0,0,1-1.949.856,2.4,2.4,0,0,1,.8.5,10.459,10.459,0,0,1,1.387,1.859l1.148,1.84h-1.855l-.832-1.481a7.629,7.629,0,0,0-1.582-2.183,1.938,1.938,0,0,0-1.219-.324h-.891v3.988Zm1.511-5.285h1.844a2.959,2.959,0,0,0,1.8-.395,1.354,1.354,0,0,0,.25-1.789,1.407,1.407,0,0,0-.645-.488,4.662,4.662,0,0,0-1.519-.164h-1.727Z",
    fill: "#1b1918",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKvLogo);
export default __webpack_public_path__ + "static/media/KVLogo.b632ac3d9ce7bacadc30ad65b24fa700.svg";
export { ForwardRef as ReactComponent };